module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraLight.8ea2657f.ttf";